import {FC, useCallback} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {AdminHeader} from "@/pages/ManagerView/AdminHeader";
import {useNavigate} from "react-router-dom";
import {QuizzesListGrid} from "./QuizzesListGrid";

const useStyles = makeStyles()((_theme) => ({
	adminQuizzesList: {
		"& th": {
			fontSize: "11px",
			fontWeight: 700,
			textTransform: "uppercase"
		}
	}
}));

/**
 * Admin Quizzes List (App2)
 *
 * Same layout/styles as legacy AdminQuizzesList.
 * Uses useListQuizzes + QuizzesListGrid (server-side pagination, filter, sort, delete).
 */
export const AdminQuizzesList: FC = () => {
	const {classes} = useStyles();
	const navigate = useNavigate();

	const onCreateClick = useCallback(() => {
		navigate("create");
	}, [navigate]);

	return (
		<Box className={classes.adminQuizzesList}>
			<AdminHeader
				title="Quizzes"
				subtitle="Manage quizzes"
				actionButtons={[{ label: "Create New", onClick: onCreateClick }]}
			/>
			<QuizzesListGrid />
		</Box>
	);
};
